import { makeStyles } from '@material-ui/styles';
import { COLORS } from '../../../styles/colors.styles';
import { Theme } from '@mui/system';
import { isKidsOrJunior } from '../../../common/utils/activeMenus';

export const customButtonStyles = makeStyles((theme: Theme) => ({
	primary: {
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: '#FAFAFA',
		backgroundColor: COLORS.primary,
		height: 40,
		borderRadius: '200px',
		padding: '10px 17px',
		[theme.breakpoints.down('md')]: {
			'&:hover': {
				backgroundColor: !isKidsOrJunior() && COLORS.primary,
			},
		},
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				backgroundColor: !isKidsOrJunior() && COLORS.primaryHover,
			},
		},

		'&:focus': {
			boxShadow: isKidsOrJunior() ? 'none' : '0 0 0 2pt #F5F5F5',
		},
		'&:active': {
			fontSize: 14,
			textTransform: 'none',
			color: '#FAFAFA',
			backgroundColor: COLORS.primary,
		},
		'&:disabled': {
			backgroundColor: COLORS.primaryDisable,
			color: '#FAFAFA',
		},
	},
	primaryNotifications: {
		boxShadow: 'none',
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: '#FAFAFA',
		backgroundColor: COLORS.primary,
		height: 40,
		borderRadius: '200px',
		padding: '10px 17px',
		[theme.breakpoints.down('md')]: {
			'&:hover': {
				backgroundColor: COLORS.primaryHover,
				boxShadow: 'none'
			},
		},
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				backgroundColor: !isKidsOrJunior() && COLORS.primaryHover,
			},
		},
		'&:focus': {
			backgroundColor: COLORS.primaryHover,
			boxShadow: 'none'
		},
		'&:active': {
			backgroundColor: COLORS.primaryHover,
			boxShadow: 'none'
		},
		'&:disabled': {
			backgroundColor: COLORS.primaryDisable,
			color: '#FAFAFA',
		},
	},
	primaryNotificationsAccept: {
		// width: '192px',
		boxShadow: 'none',
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: '#FAFAFA',
		backgroundColor: COLORS.primary,
		height: 40,
		borderRadius: '200px',
		padding: '10px 40px 10px 40px',
		[theme.breakpoints.down('md')]: {
			'&:hover': {
				backgroundColor: COLORS.primaryHover,
				boxShadow: 'none'
			},
		},
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				backgroundColor: COLORS.primaryHover,
				boxShadow: 'none'
			},
		},
		'&:focus': {
			backgroundColor: COLORS.primaryHover,
			boxShadow: 'none'
		},
		'&:active': {
			backgroundColor: COLORS.primaryHover,
			boxShadow: 'none'
		},
		'&:disabled': {
			backgroundColor: COLORS.primaryDisable,
			color: '#FAFAFA',
		},
	},
	secondary: {
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: COLORS.primary,
		backgroundColor: '#FAFAFA',
		height: 40,
		borderRadius: 'var(--border-radius-1000, 200px)',
		padding: '10px 17px',
		margin: '0 auto',
		border: '2px solid #CFCFCF',
		boxShadow: 'none',
		'&.MuiButton-contained:hover': isKidsOrJunior()
			? {}
			: {
				borderRadius: 'var(--border-radius-1000, 200px)',
				border:
					'2px solid var(--Buttons-Secondary-button-secondary-fg-hover, #E24009)',
				background:
					'var(--Buttons-Secondary-button-secondary-bg, #FAFAFA) !important',
				boxShadow: 'none',
			},
		'&:focus': {
			border: isKidsOrJunior() ? 'none' : `2px solid ${COLORS.primary}`,
		},
	},
	secondaryNotifications: {
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: COLORS.primary,
		backgroundColor: '#FAFAFA',
		height: 40,
		borderRadius: '200px',
		padding: '10px 17px',
		margin: '0 auto',
		border: `2px solid ${isKidsOrJunior() ? COLORS.KidWhite : COLORS.primary}`,
		boxShadow: 'none',
		'&:hover': {
			backgroundColor: '#CFCFCF',
			boxShadow: 'none',
		},
		'&:focus': {
			backgroundColor: '#CFCFCF',
			boxShadow: 'none',
		},
	},
	altaBizum: {
		fontSize: 14,
		textTransform: 'none',
		color: COLORS.primary,
		backgroundColor: '#FAFAFA',
		height: 40,
		borderRadius: 30,
		width: 'auto',
		border: '2px solid #CFCFCF',
		boxShadow: 'none',
		lineHeight: 'normal',
	},
	bajaBizum: {
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: COLORS.primary,
		backgroundColor: '#FAFAFA',
		height: 40,
		borderRadius: '200px',
		padding: '10px 17px',
		margin: '0 auto',
		border: `2px solid ${isKidsOrJunior() ? COLORS.KidWhite : COLORS.primary}`,
		boxShadow: 'none',
		'&:hover': {
			backgroundColor: '#CFCFCF',
			boxShadow: 'none',
		},
	},
	sendSMS: {
		fontSize: 14,
		textTransform: 'none',
		color: COLORS.primary,
		backgroundColor: 'transparent !important',
		height: 40,
		borderRadius: 30,
		width: 'auto',
		border: 'none',
		boxShadow: 'none',
		lineHeight: 'normal',
		fontWeight: 'bold',
		[theme.breakpoints.up('md')]: {
			'&.MuiButton-contained:hover': {
				backgroundColor: !isKidsOrJunior() && 'transparent !important',
				boxShadow: 'none !important',
			},
		}
	},
	bizum: {
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: '#FAFAFA',
		backgroundColor: COLORS.primary,
		height: 40,
		width: 192,
		textAlign: 'center',
		borderRadius: '200px',
		padding: '10px 17px',
		boxShadow: isKidsOrJunior() && 'none',
		'&:hover': {
			backgroundColor: COLORS.primary,
		},
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				color: '#FAFAFA',
				backgroundColor: !isKidsOrJunior() && COLORS.primary,
			},
		},
		'&:disabled': {
			backgroundColor: COLORS.primaryDisable,
			color: '#FAFAFA',
		},
		'.MuiButton-contained:hover': {
			backgroundColor: !isKidsOrJunior() && '#FAFAFA  !important',
			boxShadow: 'none',
		},
	},
	depositMovil: {
		height: 36,
		color: COLORS.primary,
		border: `2px solid ${COLORS.primary}`,
		borderRadius: 8,
		padding: '12px 2px',
		backgroundColor: 'transparent !important',
		boxShadow: 'none',
		display: 'flex',
		alignItems: 'center',
		textTransform: 'none',
		fontSize: 9,
		lineHeight: '8px',
		fontWeight: 600,
		'&:hover': {
			backgroundColor: 'transparent',
			boxShadow: 'none',
		},
	},
	depositDesktop: {
		color: COLORS.primary,
		border: `2px solid ${COLORS.primary}`,
		borderRadius: 8,
		padding: '12px 2px',
		backgroundColor: 'transparent !important',
		boxShadow: 'none',
		display: 'flex',
		alignItems: 'center',
		textTransform: 'none',
		fontSize: 10,
		fontWeight: 600,
		'&:hover': {
			backgroundColor: 'transparent',
			boxShadow: 'none',
		},
	},
	selectorMovil: {
		height: 36,
		color: COLORS.primary,
		border: `2px solid ${isKidsOrJunior() ? COLORS.KidWhite : COLORS.primary}`,
		borderRadius: 8,
		padding: '12px 2px',
		backgroundColor: '#F5F5F5 !important',
		display: 'flex',
		alignItems: 'center',
		textTransform: 'none',
		fontSize: 9,
		lineHeight: '8px',
		fontWeight: 600,
	},
	selectorDesktop: {
		color: COLORS.primary,
		border: `2px solid ${isKidsOrJunior() ? COLORS.KidWhite : COLORS.primary}`,
		borderRadius: 8,
		padding: '12px 2px',
		backgroundColor: '#F5F5F5 !important',
		display: 'flex',
		alignItems: 'center',
		textTransform: 'none',
		fontSize: 10,
		fontWeight: 600,
	},
	selectorMobileKids: {
		height: 36,
		color: COLORS.white,
		border: `2px solid ${COLORS.primary}`,
		borderRadius: 8,
		padding: '12px 2px',
		display: 'flex',
		alignItems: 'center',
		textTransform: 'none',
		fontSize: 9,
		lineHeight: '8px',
		fontWeight: 600,
	},
	selectorDesktopKids: {
		color: COLORS.white,
		border: `2px solid ${COLORS.primary}`,
		borderRadius: 8,
		padding: '12px 2px',
		display: 'flex',
		alignItems: 'center',
		textTransform: 'none',
		fontSize: 10,
		fontWeight: 600,
	},
	selectorSelected: {
		color: '#F5F5F5',
		backgroundColor: `${COLORS.primary} !important`,
		'&:hover': {
			backgroundColor: `${COLORS.primary} !important`,
		},
	},
	selectorSelectedKids: {
		color: '#363636 !important',
		backgroundColor: `${COLORS.white} !important`,
	},
	searchButton: {
		backgroundColor: COLORS.primary,
		borderRadius: 200,
		color: '#FAFAFA',
		height: 40,
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				background: !isKidsOrJunior() && COLORS.primaryHover,
			},
		}
	},
	backHomeButton: {
		backgroundColor: COLORS.primary,
		borderRadius: 200,
		color: '#FAFAFA',
		height: 43,
		paddingTop: 8,
		justifyContent: 'center',
		width: 192,
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'inherit',
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				background: !isKidsOrJunior() && COLORS.primaryHover,
			},
		}
	},
	deleteButton: {
		background: 'transparent',
		boxShadow: 'none',
		textTransform: 'none',
	},
	newDeleteButton: {
		background: '#DB3900',
		borderRadius: 200,
		textTransform: 'none',
		color: '#FAFAFA',
		padding: '10px 17px',
		height: 40,
		width: 192,
		fontWeight: 700,
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				background: !isKidsOrJunior() && COLORS.primaryHover,
			},
		}
	},
	actionsButton: {
		background: COLORS.primary,
		borderRadius: 200,
		textTransform: 'none',
		color: '#FAFAFA',
		padding: '10px 17px',
		height: 40,
		width: 192,
		fontWeight: 700,
		'&:hover': {
			background: COLORS.primary,
		},
		[theme.breakpoints.up('md')]: {
			'&:hover': {
				background: !isKidsOrJunior() && COLORS.primaryHover,
			},
		}
	},
	redCancelButton: {
		background: '#E62619',
		borderRadius: '200px',
		padding: '10px 40px',
		gap: '8px',
		height: 40,
		width: 187
	},
	newRedButton: {
		borderRadius: 4,
		boxShadow: '0px 1px 3px 0px rgba(77, 77, 75, 0.08)',
		gap: '4px',
		background: '#D52B1E',
		color: 'white',
		textTransform: 'none',
	}
}));
